import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import moment from 'moment';
import { SkyLightStateless } from 'react-skylight';
import GenericDatePicker from '../Common/GenericDatePicker';

const { Selectors } = Data;

export class MultiplePackageModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: [],
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,

            weight: "",
            length: "",
            width: "",
            depth: "",
            count: 1,

        };
        this.onChangeValue = this.onChangeValue.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.salesOrderPDF &&
            nextProps.salesOrderPDF !== this.props.salesOrderPDF
          ) {
            this.props.setMultiplePackagelVisibility(false);
          }
    }

    // initializeModal = (array) => {
    //     let index = 0;
    //     let formatter = [];
    //     if (array && array.length > 0) {
    //         array.map(r => {
    //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
    //         })
    //     } else {
    //         formatter.push({ Idx: 0, name: "", note: "" });
    //     }
    //     this.setState({
    //         rows: formatter,
    //         selectedRows: [],
    //         editedRows: [],
    //     });
    // }


    onChangeValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handlePrint = (e) => {
        e.preventDefault();

        let {rows} = this.state;
        let packages = [];
        if (rows && rows.length > 0) {
            rows.map((r,i) => {
                packages.push({

                    Weight: {
                        Value: Number(r.weight),
                        Unit: "LB",
                    },
                    Dimensions: {
                        Length: Number(r.length),
                        Width: Number(r.width),
                        Depth: Number(r.depth),
                        Unit: "IN",
                    },
                    IdenticalPackageCount: Number(r.count),

                })
            });
        }

        this.props.selectTeapplixShipping('', this.props.singleSalesOrderId, packages);
    }


    clickNew(e) {
        e.preventDefault();
        let {weight, length, width, depth, count} = this.state;
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = { weight: weight, length: length, width: width, depth: depth, count: count, Idx: index };
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({ rows, editedRows });

        this.setState({weight: "", count: 1, length: "", width: "", depth: ""});
    }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

        if (this.state.selectedRows[0].id) {
            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
            //     alert("Agent Deleted");
            //     rows.splice(index, 1);
            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
            //     editedRows.splice(index, 1);
            //     this.setState({ rows, editedRows, selectedRows: [] })
            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
            //     //     if (response.data) {
            //     //         this.initializeModal(response.data);
            //     //     }
            //     // }, (err) => {
            //     //     if (err.status === 500 || err.status === 404) {
            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
            //     //     }
            //     // });
            // }, (err) => {
            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
            //         alert("Error cannot delete agent.");
            //     }
            // });
        }

        // rows.splice(index, 1);
        // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        // editedRows.splice(index, 1);
        // this.setState({ rows, editedRows, selectedRows: [] })
    }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        const columns = [
            // {
            //     key: 'so_num',
            //     name: <Translate value="so_num" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 160,
            // },
            {
                name: <Translate value="action" />,
                width: 160,
                resizable: true,
                filterable: true,
                getRowMetaData: (row, idx) => ({ ...row, idx }),
                formatter: (props) => {
                  return (<div
                    onDoubleClick={() => {
                      const rows = [...this.state.rows];
                      rows.splice(props.dependentValues.Idx, 1);
                      this.setState({rows});
                    }}
                    style={{ cursor: 'pointer', color: 'red', width: '100%', textAlign: 'center' }}
                    >Delete</div>)
                },
              },
            //   {
            //     key: 'Idx',
            //     name: <Translate value="idx" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 160,
            // },
            {
                key: 'weight',
                name: <Translate value="weight(lbs)" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },
            {
                key: 'length',
                name: <Translate value="length(in)" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },

            {
                key: 'width',
                name: <Translate value="width(in)" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },
            {
                key: 'depth',
                name: <Translate value="depth(in)" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },
            {
                key: 'count',
                name: <Translate value="package_amnt" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },
            // {
            //     key: "is_3party",
            //     name: <Translate value="3rd_party" />,
            //     resizable: true,
            //     sortable: true,
            //     // filterable: true,
            //     width: 160,
            //     formatter: ({ value }) => (
            //         <div>
            //             {(value === true || value === 'true') ? "true" : "false"}
            //         </div>
            //     ),
            // },
        ];

        const onRowClick = (rowIdx, row) => {
            if (rowIdx !== -1) {
                const rows = getRows();
                rows.map((r) => {
                    r.isSelected = false;
                });
                const selectedRows = [rows[rowIdx]];
                rows[rowIdx].isSelected = true;
                this.setState({ rows, selectedRows });

                //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
                //   this.setState({ salesOrders });
                //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
                let temp = {
                    rows: [],
                    selectedRows: null,
                    editedRows: [],
                    filters: {},
                };
                if (selectedRows && selectedRows[0]) {
                    temp.rows = selectedRows[0].lines;
                    this.setState({ details: temp });
                }
            }
        };

        return (
            <Row>
                <Col>
                    {/* <div style={{ maxWidth: '550px', marginLeft: '25px' }}> */}
                    {/* <div style={{marginTop: "100px"}}> */}
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            onGridSort={handleGridSort}
                            onAddFilter={handleFilterChange}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={295}
                            rowHeight={25}
                            headerRowHeight={45}
                            toolbar={<Toolbar enableFilter />}
                            // enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            // rowSelection={{
                            //     showCheckbox: true,
                            //     onRowsSelected,
                            //     onRowsDeselected,
                            //     selectBy: {
                            //         isSelectedKey: 'isSelected'
                            //     }
                            // }}
                            // onRowClick={onRowClick}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;


        return (
            <div>

                {/* <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar> */}
                <Row style={{marginLeft: '20px'}}>
                    <Col sm={2}>
                        <label><Translate value="weight(lbs)" /></label>
                    </Col>
                    <Col sm={2}>
                        <label><Translate value="length(inches)" /></label>
                    </Col>
                    <Col sm={2}>
                        <label><Translate value="width(inches)" /></label>
                    </Col>
                    <Col sm={2}>
                        <label><Translate value="depth(inches)" /></label>
                    </Col>
                    <Col sm={2}>
                        <label><Translate value="package_amount" /></label>
                    </Col>
                </Row>
                <Row style={{marginLeft: '20px'}}>
                    <Col sm={2}>
                        <Input type="text" name="weight" value={this.state.weight} onChange={this.onChangeValue} />
                    </Col>
                    <Col sm={2}>
                        <Input type="text" name="length" value={this.state.length} onChange={this.onChangeValue} />
                    </Col>
                    <Col sm={2}>
                        <Input type="text" name="width" value={this.state.width} onChange={this.onChangeValue} />
                    </Col>
                    <Col sm={2}>
                        <Input type="text" name="depth" value={this.state.depth} onChange={this.onChangeValue} />
                    </Col>
                    <Col sm={2}>
                        <Input type="text" name="count" value={this.state.count} onChange={this.onChangeValue} />
                    </Col>
                    <Col sm={2} style={{marginTop: "-2px"}}>
                        <Button
                            bsStyle="success"
                            disabled={!this.state.weight || !this.state.length || !this.state.width || !this.state.depth || !this.state.count}
                            onClick={(event) => { this.clickNew(event) }}
                        >
                            <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <div style={{ padding: '0px 25px' }}>
                            {this.renderAgentTable()}
                        </div>
                    </Col>
                </Row>


                <Row className="centerStyle" style={{ marginTop: '15px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        disabled={this.state.rows.length < 1}
                        onClick={(e) => { this.handlePrint(e); }}
                    >
                        <Translate value="print_label" />
                    </Button>
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="warning"
                        onClick={(e) => { this.setState({ editShipDateVisible: true }); }}
                        disabled={this.state.selectedRows.length !== 1}
                    >
                        <Translate value="ship_date" />
                    </Button> */}
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleExcel(e); }}
                        disabled={this.state.selectedRows && this.state.selectedRows.length !== 1}
                    >
                        <em className="fa fa-download" />
                        <Translate value="export_excel" />
                    </Button> */}

                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>


            </div>
        );
    }
}

export default MultiplePackageModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/MultiplePackageModal.jsx